function HourglassLow(props) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_5600_24586)">
        <path
          d="M12 12L6.3 7.725C6.20685 7.65514 6.13125 7.56455 6.07918 7.46041C6.02711 7.35627 6 7.24143 6 7.125V3.75C6 3.55109 6.07902 3.36032 6.21967 3.21967C6.36032 3.07902 6.55109 3 6.75 3H17.25C17.4489 3 17.6397 3.07902 17.7803 3.21967C17.921 3.36032 18 3.55109 18 3.75V7.09125C17.9996 7.20689 17.9725 7.32088 17.9208 7.42432C17.8691 7.52775 17.7942 7.61783 17.7019 7.6875L12 12Z"
          stroke="#3F3C43"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 12L6.3 16.275C6.20685 16.3449 6.13125 16.4354 6.07918 16.5396C6.02711 16.6437 6 16.7586 6 16.875V20.25C6 20.4489 6.07902 20.6397 6.21967 20.7803C6.36032 20.921 6.55109 21 6.75 21H17.25C17.4489 21 17.6397 20.921 17.7803 20.7803C17.921 20.6397 18 20.4489 18 20.25V16.9088C17.9999 16.7928 17.973 16.6784 17.9212 16.5746C17.8695 16.4709 17.7944 16.3805 17.7019 16.3106L12 12Z"
          stroke="#3F3C43"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M6 17.25H18" stroke="#3F3C43" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_5600_24586">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default HourglassLow;
